import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const SQUARE_APP_ID = process.env.REACT_APP_SQUARE_APPLICATION_ID;
export const SQUARE_LOCATION_ID = process.env.REACT_APP_SQUARE_LOCATION_ID;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ipv_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const fileUrl = (path) =>
  path?.startsWith("http") ? path : `${API}/files/${path}`;

export const fmtMoney = (v) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(v || 0);
